// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.draft-profile-image__file-wrapper {
    position: relative;
    width: 200px;
}
.draft-profile-image__file-wrapper img {
    width: 100%;
}
.draft-profile-image__buttons {
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./client/components/files/DraftProfileImage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".draft-profile-image__file-wrapper {\n    position: relative;\n    width: 200px;\n}\n.draft-profile-image__file-wrapper img {\n    width: 100%;\n}\n.draft-profile-image__buttons {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
